function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M46.75 22.1c.159.134.25.33.25.535v5.005c0 .39-.323.707-.722.707a.715.715 0 01-.722-.707v-4.184l-24.235 3.519a.74.74 0 01-.208 0L2.444 24.361V42.95l4.253.596a.71.71 0 01.613.8.72.72 0 01-.817.6l-4.873-.682a.712.712 0 01-.62-.7V23.545c0-.205.09-.4.249-.534a.732.732 0 01.575-.166l19.39 2.715 24.958-3.625c.208-.03.419.03.578.165zm-.472 9.836c.399 0 .722.317.722.708v10.009c0 .35-.262.648-.616.7l-25.063 3.64a.74.74 0 01-.208 0l-9.746-1.365a.71.71 0 01-.613-.8.72.72 0 01.817-.601l9.642 1.35 24.343-3.535v-9.398c0-.39.323-.708.722-.708z",
  fill: "#2D2D2D"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M43.197 38.772a.71.71 0 01-.609.804l-1.642.238a.72.72 0 01-.82-.596.71.71 0 01.608-.804l1.642-.239a.72.72 0 01.82.597zM38.636 39.354a.71.71 0 01-.595.813l-4.493.721a.72.72 0 01-.83-.584.71.71 0 01.596-.813l4.493-.721a.72.72 0 01.83.584zM21.215 25.567c.399 0 .722.317.722.708v20.017c0 .391-.323.708-.722.708a.715.715 0 01-.722-.708V26.275c0-.391.323-.708.722-.708zM5.435 27.387c.399 0 .722.317.722.707v1.82c0 .391-.323.708-.722.708a.715.715 0 01-.722-.708v-1.82c0-.39.323-.707.722-.707zM5.435 32.846c.399 0 .722.317.722.708v4.55c0 .39-.323.707-.722.707a.715.715 0 01-.722-.708v-4.55c0-.39.323-.707.722-.707zM20.83 1.11a.733.733 0 01.385-.11h15.78c.296 0 .561.176.67.445l7.427 18.198a.7.7 0 01-.285.86l-6.329 3.92a.73.73 0 01-.996-.22.7.7 0 01.225-.977l5.821-3.604-7.021-17.207H21.424L4.47 12.912l4.539 11.3a.703.703 0 01-.408.918.727.727 0 01-.936-.4L2.907 12.886a.7.7 0 01.286-.858L20.83 1.109z",
  fill: "#2D2D2D"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M34.886 6.504a.726.726 0 01.93.415l1.392 3.64a.704.704 0 01-.423.91.726.726 0 01-.93-.414l-1.392-3.64a.704.704 0 01.423-.91zM37.596 13.016a.727.727 0 01.942.385l.606 1.442a.703.703 0 01-.393.924.727.727 0 01-.943-.386l-.605-1.442a.703.703 0 01.393-.923zM2.856 12.627c0-.391.324-.708.722-.708h15.78c.297 0 .563.177.672.447l1.328 3.286a.703.703 0 01-.405.919.727.727 0 01-.937-.397l-1.148-2.84H3.578a.715.715 0 01-.722-.707zM21.75 18.54c.37-.143.79.035.937.398l2.656 6.573a.703.703 0 01-.405.918.727.727 0 01-.937-.397l-2.656-6.573a.703.703 0 01.405-.919z",
  fill: "#2D2D2D"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.136 1.33a.7.7 0 01-.225.976L11.794 12.907l1.269 3.02a.703.703 0 01-.393.923.727.727 0 01-.943-.385l-1.499-3.57a.7.7 0 01.282-.867L28.14 1.11a.73.73 0 01.996.22zM37.606 1.33a.7.7 0 01-.225.976L19.745 13.225a.73.73 0 01-.996-.22.7.7 0 01.225-.977L36.61 1.11a.73.73 0 01.996.22z",
  fill: "#2D2D2D"
});

function SvgPending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default __webpack_public_path__ + "/img/pending.svg";
export { SvgPending as ReactComponent };